if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      let announceStatus = window.sessionStorage.getItem('closed-announcement');
      if ( announceStatus == null ) {
        this.classList.remove('hidden')
        this.classList.add('flex')
      }
    }

    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-close-announcement]')) {
          this.classList.add('-translate-x-full', 'opacity-0');
          window.sessionStorage.setItem('closed-announcement', 'true'); //-Hide announcement till new session/tab
        }
      })
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}